import React from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemSubType } from '../../../Enums/WizardItemSubtype.enum';
import LinkButton from '../../../../BaseModule/Components/Button/LinkButton/LinkButton';
import { resolveWizardAction } from '../../../Services/wizard.service';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import Button from '../../../../BaseModule/Components/Button/Button/Button';
import { Theme } from '../../../../BaseModule/Enums/Theme.enum';
import { WizardActionDestination } from '../../../Enums/WizardActionDestination.enum';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.BUTTON }>;
	onSubmit: (data: object) => void;
}

const WizardButton: React.FC<Props> = ({ item, onSubmit }) => {
	const action = item.settings?.action;
	const browserUrl =
		action?.destination === WizardActionDestination.BROWSER
			? action.url
			: undefined;

	const handleClick = () => {
		if (action) {
			resolveWizardAction(action);
		} else {
			onSubmit({ ...(item.data ?? {}) });
		}
	};

	switch (item.subtype) {
		case WizardItemSubType.TEXT:
			return (
				<LinkButton
					text={item.title}
					theme='purple'
					href={browserUrl}
					onClick={browserUrl ? undefined : handleClick}
				/>
			);
		default:
			return (
				<Button
					onClick={browserUrl ? undefined : handleClick}
					href={browserUrl}
					title={item.title}
					icon={item.settings?.icon}
					badge={item.settings?.badge?.text}
					theme={item.settings?.theme as Theme}
				/>
			);
	}
};

export default WizardButton;
